let currentHoverTimeout = null;
let currentExpandedItem = null;
let sliderInstances = new Map();

document.addEventListener('DOMContentLoaded', function() {
  
  // Slider-specific initialization
  const sliders = document.querySelectorAll('[id*="stvs-slider-container-"]');
  if (sliders.length === 0) {
    console.log('No slider containers found, slider.js exiting');
    return;
  }

  // Initialize all sliders
  initializeSliders();
  
  // Initialize hover effects for sliders
  initializeHoverEffects();

  // Give the elementor widget a higher z-index
  markElementorWidget();
});

function markElementorWidget() {
  const sliderContainer = document.querySelector('.stvs-store-slider-plugin-container');
  if (!sliderContainer) return;
  
  let element = sliderContainer;
  while (element && !element.classList.contains('elementor-widget')) {
    element = element.parentElement;
  }
  
  if (element) {
    element.classList.add('stvs-has-slider');
  }
}

function initializeSliders() {
  const sliders = document.querySelectorAll('[id*="stvs-slider-container-"]');
  
  sliders.forEach(slider => {
    initializeSlider(slider);
  });
}

function initializeSlider(container) {
  const track = container.querySelector('.stvs-slider-track');
  const prevBtn = container.querySelector('.stvs-slider-prev');
  const nextBtn = container.querySelector('.stvs-slider-next');
  const items = container.querySelectorAll('.stvs-slider-item');
  const wrapper = container.querySelector('.stvs-slider-wrapper');
  
  if (!track || !prevBtn || !nextBtn || items.length === 0) {
    console.log('Missing slider elements for:', container.id);
    return;
  }

  wrapper.style.overflow = 'visible';
  
  let currentOffset = 0;
  let itemWidth = 0;
  let visibleItems = 0;
  
  function calculateDimensions() {
    const containerWidth = container.offsetWidth;
    const gap = 8; // 0.5rem gap between items
    
    // Define exact breakpoints based on container size
    let targetItemsVisible;
    
    if (containerWidth >= 1280) {
      targetItemsVisible = 5;
    } else if (containerWidth >= 768) {
      targetItemsVisible = 4;
    } else if (containerWidth >= 640) {
      targetItemsVisible = 3;
    } else if (containerWidth >= 360) {
      targetItemsVisible = 2;
    } else {
      targetItemsVisible = 1;
    }
    
    // Ensure we don't exceed available items
    visibleItems = Math.min(targetItemsVisible, items.length);
    
    // Calculate perfect fit width
    const totalGapWidth = (visibleItems - 1) * gap;
    const availableWidth = containerWidth - totalGapWidth;
    itemWidth = availableWidth / visibleItems;
    
    // Apply sizing
    const sliderItems = container.querySelectorAll('.stvs-slider-item');
    sliderItems.forEach(item => {
      item.style.minWidth = `${itemWidth}px`;
      item.style.maxWidth = `${itemWidth}px`;
      item.style.width = `${itemWidth}px`;
    });
    
    updateNavigationState();
  }

  function updateNavigationState() {
    const totalWidth = items.length * (itemWidth + 8);
    const maxOffset = Math.max(0, totalWidth - container.offsetWidth);
    
    prevBtn.disabled = currentOffset <= 0;
    nextBtn.disabled = currentOffset >= maxOffset;
    
    track.style.transform = `translateX(-${currentOffset}px)`;
  }

  function slideNext() {
    const totalWidth = items.length * (itemWidth + 8);
    const maxOffset = Math.max(0, totalWidth - container.offsetWidth);
    
    if (currentOffset < maxOffset) {
      currentOffset = Math.min(currentOffset + (itemWidth + 8), maxOffset);
      updateNavigationState();
    }
  }

  function slidePrev() {
    if (currentOffset > 0) {
      currentOffset = Math.max(currentOffset - (itemWidth + 8), 0);
      updateNavigationState();
    }
  }
  
  nextBtn.addEventListener('click', slideNext);
  prevBtn.addEventListener('click', slidePrev);
  window.addEventListener('resize', () => {
    currentOffset = 0;
    calculateDimensions();
  });
  
  calculateDimensions();

  setupPopupSpace();
  
  function setupPopupSpace() {
    const wrapper = container.querySelector('.stvs-slider-wrapper');
    const firstItem = container.querySelector('.stvs-slider-item');
    
    if (wrapper && firstItem) {
      const itemHeight = firstItem.offsetHeight;
      const popupHeight = 554; // popup height
      const extraSpace = popupHeight - itemHeight;
      
      wrapper.style.minHeight = `${popupHeight}px`;
      wrapper.style.marginBottom = `-${extraSpace}px`;
 
    }
  }
  
  sliderInstances.set(container.id, {
    calculateDimensions,
    slideNext,
    slidePrev,
    destroy: () => {
      nextBtn.removeEventListener('click', slideNext);
      prevBtn.removeEventListener('click', slidePrev);
      window.removeEventListener('resize', calculateDimensions);
      sliderInstances.delete(container.id);
    }
  });
  
}

function initializeHoverEffects() {
  const sliderContainers = document.querySelectorAll('[id^="stvs-slider-container-"]');
  
  sliderContainers.forEach(container => {
    addHoverListeners(container);
  });
}

function addHoverListeners(container) {
  container.removeEventListener('mouseenter', handleItemHoverStart, true);
  container.removeEventListener('mouseleave', handleItemHoverEnd, true);
  
  container.addEventListener('mouseenter', handleItemHoverStart, true);
  container.addEventListener('mouseleave', handleItemHoverEnd, true);
}

function handleItemHoverStart(e) {
  const storeItem = e.target.closest('.stvs-store-item');
  if (!storeItem) return;

  if (currentHoverTimeout) {
    clearTimeout(currentHoverTimeout);
    currentHoverTimeout = null;
  }

  if (currentExpandedItem && currentExpandedItem !== storeItem) {
    closeExpandedItem(currentExpandedItem);
  }

  currentHoverTimeout = setTimeout(() => {
    if (storeItem.classList.contains('stvs-expanded')) return;
    expandItem(storeItem);
    currentExpandedItem = storeItem;
    currentHoverTimeout = null;
  }, 650);
}

function handleItemHoverEnd(e) {
  const storeItem = e.target.closest('.stvs-store-item');
  if (!storeItem) return;

  const relatedTarget = e.relatedTarget;
  if (relatedTarget && storeItem.contains(relatedTarget)) {
    return;
  }

  if (currentHoverTimeout) {
    clearTimeout(currentHoverTimeout);
    currentHoverTimeout = null;
  }

  if (currentExpandedItem === storeItem) {
    closeExpandedItem(storeItem);
    currentExpandedItem = null;
  }
}

function expandItem(storeItem) {
  if (window.innerWidth < 1024) {
    return;
  }
  // Calculate alignment relative to slider container
  const alignment = calculateAlignment(storeItem);
  const overlay = storeItem.querySelector('.stvs-hover-overlay');
  
  overlay.classList.remove('stvs-align-left', 'stvs-align-center', 'stvs-align-right');
  overlay.classList.add(`stvs-align-${alignment}`);

  const videoUrl = storeItem.dataset.videoUrl;
  storeItem.classList.add('stvs-expanded');
  morphBadges(storeItem, 'expand');
  if (videoUrl) {
    loadVideo(storeItem, videoUrl);
  }
}

function calculateAlignment(storeItem) {
  // Slider-specific logic - calculate relative to slider container
  const sliderItem = storeItem.closest('.stvs-slider-item');
  const slider = storeItem.closest('[id^="stvs-slider-container-"]');
  const overlay = storeItem.querySelector('.stvs-hover-overlay');
  
  if (!sliderItem || !slider) return 'center';
  
  const itemRect = storeItem.getBoundingClientRect();
  const sliderRect = slider.getBoundingClientRect();
  const overlayWidth = 800;
  let doAdjust = false;

  if (window.innerWidth < 1124) {
    overlay.style.width = '600px';
    overlay.querySelector('.stvs-expanded-content').style.width = '600px';
    doAdjust = true;
  } else {
    overlay.style.width = '800px';
    overlay.querySelector('.stvs-expanded-content').style.width = '800px';
  }
  
  const spaceOnLeft = itemRect.left - sliderRect.left;
  const spaceOnRight = sliderRect.right - itemRect.right;
  const itemCenter = itemRect.left + (itemRect.width / 2);
  
  const centeredLeft = itemCenter - (overlayWidth / 2);
  const centeredRight = itemCenter + (overlayWidth / 2);
  
  if (centeredLeft >= sliderRect.left && centeredRight <= sliderRect.right) {
    return 'center';
  }
  
  if (spaceOnRight > spaceOnLeft) {
    return 'left';
  }
  if (doAdjust) {
    overlay.setAttribute('style', 'right:0px !important;width:600px !important;');
    overlay.querySelector('.stvs-expanded-content').setAttribute('style', 'right:0px !important;width:600px !important;');
  } else {
    overlay.setAttribute('style', '');
    overlay.querySelector('.stvs-expanded-content').setAttribute('style', '');
  }
  return 'right';
}

function closeExpandedItem(storeItem) {
  morphBadges(storeItem, 'collapse');
  storeItem.classList.remove('stvs-expanded', 'stvs-animation-complete');
  
  const videoContainer = storeItem.querySelector('.stvs-video-container');
  if (videoContainer) {
    const video = videoContainer.querySelector('video');
    if (video) {
      video.pause();
      video.remove();
    }
    videoContainer.classList.remove('stvs-video-loaded');
  }
}

function morphBadges(storeItem, direction) {
  const originalBadges = storeItem.querySelectorAll('.stvs-item-badge');
  const expandedBadgesContainer = storeItem.querySelector('.stvs-expanded-badges');
  
  if (!expandedBadgesContainer) return;
  
  if (direction === 'expand') {
    expandedBadgesContainer.innerHTML = '';
    
    originalBadges.forEach((badge, index) => {
      const clonedBadge = badge.cloneNode(true);
      
      clonedBadge.classList.add('stvs-badge-horizontal');
      clonedBadge.classList.remove('stvs-absolute', 'stvs-top-0', 'stvs-top-[30px]', 'stvs-top-[60px]', 'stvs-left-0', 'stvs-left-[50%]', 'stvs-flex-col');
      clonedBadge.classList.add('stvs-relative', 'stvs-rounded-md');
      
      for (const child of clonedBadge.children) {
        child.classList.remove('stvs-rounded-br-md', 'stvs-rounded-e-md', 'stvs-rounded-tr-md');
        child.classList.add('stvs-rounded-md');
      }
      
      clonedBadge.style.opacity = '0';
      clonedBadge.style.transform = 'translateY(20px)';
      
      expandedBadgesContainer.appendChild(clonedBadge);
      
      setTimeout(() => {
        clonedBadge.style.transition = 'all 0.3s ease';
        clonedBadge.style.opacity = '1';
        clonedBadge.style.transform = 'translateY(0)';
      }, index * 100);
    });
    
    originalBadges.forEach(badge => {
      badge.style.transition = 'opacity 0.3s ease';
      badge.style.opacity = '0';
    });
    
  } else if (direction === 'collapse') {
    originalBadges.forEach(badge => {
      badge.style.opacity = '1';
    });
    
    setTimeout(() => {
      expandedBadgesContainer.innerHTML = '';
    }, 300);
  }
}

function loadVideo(storeItem, videoUrl) {
  const videoContainer = storeItem.querySelector('.stvs-video-container');
  if (!videoContainer || !videoUrl) return;

  const video = document.createElement('video');
  video.src = videoUrl;
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.autoplay = true;
  
  video.addEventListener('loadeddata', () => {
    videoContainer.classList.add('stvs-video-loaded');
  });
  
  video.addEventListener('error', (e) => {
    console.log('Video failed to load:', e);
  });
  
  videoContainer.appendChild(video);
}